"use client";
import { jsx, Fragment } from "react/jsx-runtime";
import "./bold.css.js";
import "./book.css.js";
import "./medium.css.js";
import "./regular.css.js";
const CupraFont = () => jsx(Fragment, {});
export {
  CupraFont
};
